import { ActionLabelValue } from '../shared.interfaces';

export class OrganizationUserPermission {
    id: number;
    email: string;
    firstName: string;
    lastName: string;
    permissionId: number;
    permissionName: string;
    validUntil: string;
    neverExpires: boolean;
    isPending: boolean;
    options: ActionLabelValue<OrganizationUserPermission>[] = [];
    get isOwner(): boolean {
        return this.permissionId === 1;
    }

    get isAdmin(): boolean {
        return this.permissionId === 2;
    }

    get isMember(): boolean {
        return this.permissionId === 3;
    }
}
